import { render, staticRenderFns } from "./ServerViewerClient.vue?vue&type=template&id=f6a84ee0&scoped=true"
import script from "./ServerViewerClient.vue?vue&type=script&lang=js"
export * from "./ServerViewerClient.vue?vue&type=script&lang=js"
import style0 from "./ServerViewerClient.vue?vue&type=style&index=0&id=f6a84ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a84ee0",
  null
  
)

export default component.exports